import classNames from 'classnames';
import { Link } from 'gatsby';
import parser from 'html-react-parser';
import React from 'react';
import {
  bottomBorder,
  ourWorkSpRow,
  ourworkFullWhiteSec,
} from './Content15.module.css';

export default function Content15({ data }) {
  const {
    content15BottomText,
    content15ButtonText,
    content15Title,
    content15Text,
    content15Subtitle,
    content15FeaturesTitle,
    content15FeaturesList,
    content15ButtonLink,
    content15ButtonExternalLink,
    content15ShowBottomBorder,
  } = data;

  return (
    <div className={classNames('ourwork-full-white-sec', ourworkFullWhiteSec)}>
      <div className='container'>
        <div
          className={classNames(
            'row',
            'our-work-sp-row',
            ourWorkSpRow,
            content15ShowBottomBorder && bottomBorder
          )}
        >
          <div className='col-md-8'>
            <div className='ow-lt-content-sec'>
              <h3 className='heading-level-3 black-color'>
                {content15Title && parser(content15Title)}
              </h3>
              <div className='heading-level-4 blue-color'>
                {content15Subtitle && parser(content15Subtitle)}
              </div>
              <p>{content15Text && parser(content15Text)}</p>
              {content15ButtonExternalLink ? (
                <a href={content15ButtonExternalLink} className="btn blue-btn">
                  {content15ButtonText}
                </a>
              ) : content15ButtonLink ? (
                <Link to={content15ButtonLink.uri} className='btn blue-btn'>
                  {content15ButtonText}
                </Link>
              ) : null}
              <p>
                <em>{content15BottomText && parser(content15BottomText)}</em>
              </p>
            </div>
          </div>
          <div className='col-md-4'>
            <div className='key-feature-sec'>
              <div className='heading-level-3 blue-color'>
                {content15FeaturesTitle && parser(content15FeaturesTitle)}
              </div>
              {content15FeaturesList && parser(content15FeaturesList)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
